import WPXForm from '@/components/templates/WPXForm/WPXForm.vue'
import WPXFormValue from '@/components/templates/WPXForm/WPXFormValue';

export default WPXForm

export {
  WPXFormValue,
}
